import React from 'react';
import style from './tab-selector.module.scss';

type Props = {
	selected: string;
	tabs: {
		label: string;
		value: string;
	}[];
	onSwitch: (value: string) => void;
};

export function TabSelector(props: Props) {
	const { tabs, onSwitch, selected } = props;

	return (
		<div className={style.tabSelector}>
			{tabs.map((tab) => {
				return (
					<button
						key={tab.value}
						data-selected={selected === tab.value}
						onClick={() => onSwitch(tab.value)}
					>
						{tab.label}
					</button>
				);
			})}
		</div>
	);
}
